import { object, string, number } from "yup";
import { MAX_POS_X, MAX_POS_Y } from "./default-values";
import { sendToArray } from "pages/graphicset/utils";

export const layoutValidationSchema = (requiredText, intl) => {
  const invalidSizeRange = intl.formatMessage({ id: "app.form.sizerange.invalid" });
  const invalidPosRange = intl.formatMessage(
    {
      id: "app.form.posrange.invalid",
    },
    { maxX: MAX_POS_X, maxY: MAX_POS_Y },
  );
  const notANumber = intl.formatMessage({ id: "app.form.notanumber" });
  const invalidNumber = intl.formatMessage({ id: "app.form.number.invalid" });
  const invalidAsset = intl.formatMessage({ id: "app.form.invalidAssetValue" });
  const invalidNewAsset = intl.formatMessage({ id: "app.form.invalidNewAssetValue" });

  return object().shape({
    assetId: string().when(["asset.image"], {
      is: assetDisplay => !assetDisplay,
      then: string().required(invalidAsset),
    }),
    asset: object()
      .shape({
        codename: string(),
        image: string(),
        description: string(),
      })
      .test("assetIdOrNewAsset", invalidNewAsset, obj => {
        return Boolean(obj.codename) === Boolean(obj.image);
      }),
    sendTo: string()
      .oneOf(sendToArray)
      .required(requiredText),
    pos: object()
      .shape({
        x: number()
          .default(null)
          .typeError(notANumber)
          .required(requiredText)
          .min(0, invalidPosRange)
          .max(MAX_POS_X, invalidPosRange),
        y: number()
          .default(null)
          .typeError(notANumber)
          .required(requiredText)
          .min(0, invalidPosRange)
          .max(MAX_POS_Y, invalidPosRange),
      })
      .required(requiredText),
    size: object()
      .shape({
        x: number()
          .typeError(notANumber)
          .required(requiredText)
          .min(0, invalidSizeRange),
        y: number()
          .typeError(notANumber)
          .required(requiredText)
          .min(0, invalidSizeRange),
      })
      .required(requiredText),
    seconds: number()
      .typeError(notANumber)
      .required(requiredText)
      .min(0, invalidNumber),
  });
};
